import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { GroupProvider } from './contexts/GroupContext';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import EmployeeList from './components/Employee/EmployeeList';
import DocumentList from './components/Document/DocumentList';
import DigiLockerPage from './pages/DigiLockerPage';
import LoginPage from './pages/LoginPage';
import GroupManagement from './pages/GroupManagement';
import CustomerManagement from './pages/CustomerManagement';
import UserManagement from './pages/UserManagement';
import SettingsPage from './pages/SettingsPage';
import { authToken } from './services/api';
import './App.css';

// Check if token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const payload = JSON.parse(jsonPayload);
    const exp = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= exp;
  } catch (e) {
    return true; // If can't decode, consider expired
  }
};

function AppContent() {
  const { updateUser, clearUser } = useAuth();
  const [isAuthed, setAuthed] = useState(() => {
    // bootstrap from storage and check expiration
    try {
      const a = localStorage.getItem('accessToken');
      if (a && !isTokenExpired(a)) {
        authToken.bootstrap();
        updateUser(a);
        return true;
      } else if (a) {
        // Token exists but expired, clear it
        authToken.clear();
      }
    } catch (_) {}
    return false;
  });

  if (!isAuthed) {
    return <LoginPage onLoggedIn={(tokens) => {
      authToken.set(tokens.accessToken, tokens.refreshToken);
      updateUser(tokens.accessToken);
      setAuthed(true);
    }} />;
  }

  const handleLogout = async () => {
    try {
      authToken.clear();
      clearUser();
      setAuthed(false);
    } catch (_) {
      authToken.clear();
      clearUser();
      setAuthed(false);
    }
  };

  return (
    <GroupProvider>
      <Router>
        <Layout onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/employees" element={<EmployeeList />} />
            <Route path="/documents" element={<DocumentList />} />
            <Route path="/digilocker" element={<DigiLockerPage />} />
            <Route path="/groups" element={<GroupManagement />} />
            <Route path="/customers" element={<CustomerManagement />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </Layout>
      </Router>
    </GroupProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
